import { debounce } from './throttle-debounce';

export default class ContentPopup {
    constructor() {
        this.dom = {
            $window: $(window),
            $body: $('body'),
            $trigger: $('.content-popup-trigger'),
            $popup: $('.content-popup'),
            $focusElement: null
        };

        if (this.dom.$popup.length) {
            this.init();
        }
    }

    init() {
        this.eventOpenPopup();
        this.eventClosePopup();
        this.eventResize();
    }

    open() {
        //Remember last focus
        this.dom.$focusElement = $(':focus');
        this.dom.$body.addClass('content-popup-visible');
        this.$popup.addClass('visible');
        this.$popup.show();
        this.setPopupPosition();
        if (this.$popup.find('.btn').length > 0) {
            if (this.$popup.find('.btn.default').length > 0) {
                this.$popup.find('.btn.default').focus();
            } else {
                this.$popup.find('.btn').eq(0).focus();
            }
        }
    }

    close($popupObj) {
        this.dom.$body.removeClass('content-popup-visible');
        if ($popupObj) {
            $popupObj.removeClass('visible');//.hide();
            $popupObj.parent(".popup-wrap").removeClass('visible').hide();
            $popupObj.closest(".model-content").hide();

            if (this.$currentTrigger) {
                if (this.$currentTrigger.hasClass('js-remote-popup')) {
                    $popupObj.remove();
                } else {
                    this.$popup = false;
                }

                if (!$popupObj.hasClass('pdf-popup')) this.$currentTrigger = false;
            }
            //Return focus
            if (this.dom.$focusElement != null && this.dom.$focusElement.length > 0) this.dom.$focusElement.focus();
        }
    }

    buildStructure($content) {
        let strokeColour = $('section.agent').length > 0 ? '#009941' : '#adda43';
        return `
            <div class="content-popup trigger-popup ${$content.attr('data-class') ? $content.attr('data-class') : ''}">
                <a href="#" class="content-popup-close">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.828 12.828">
                        <g id="close" transform="translate(1.414 1.414)">
                            <line fill="none" stroke="${strokeColour}" stroke-linecap="round"
                             stroke-width="2px" data-name="Line 28" x2="10" y2="10"/>
                            <line fill="none" stroke="${strokeColour}" stroke-linecap="round" stroke-width="2px"
                             data-name="Line 29" x2="10" y2="10" transform="translate(10) rotate(90)"/>
                        </g>
                    </svg>
                </a>
                <div class="content-popup-inner">${$content.html()}</div>
            </div>
        `;
    }

    setPopupPosition() {
        if (!this.$popup || !this.$currentTrigger) {
            return;
        }

        let offset = this.$currentTrigger.offset();
        let top;
        let left;

        if (this.$popup.hasClass('popup-full-width') || this.$popup.hasClass('center')) return;

        top = Math.max(0, offset.top - (this.$popup.outerHeight() / 2));
        left = this.$popup.hasClass('wide-popup') ? '50%' : (offset.left + (this.$currentTrigger.width() / 3));

        this.$popup.css({
            top,
            left
        });
    }

    eventOpenPopup() {
        var trigType;
        var $this = this;

        this.dom.$trigger.each(function () {

            trigType = $(this).data('trigger') || 'click';

            $(this).off(trigType).on(trigType, (e) => {
                var thisEvent = ($(e.currentTarget).data('trigger') || 'click');

                if (thisEvent == 'click') {
                    e.preventDefault();
                }
                if ((thisEvent == 'change') && $(e.currentTarget).attr('type') == 'checkbox' && $(e.currentTarget).prop('checked') != ($(e.currentTarget).data('condition') == 'false')) {
                    return true;
                }

                $this.$currentTrigger = $(e.currentTarget);
                let targetClass = $this.$currentTrigger.data('target');

                //Check target exists
                if (targetClass != undefined) {
                    let $target = $(targetClass);

                    if ($this.$currentTrigger.hasClass('js-remote-popup')) {
                        $this.dom.$body.append($this.buildStructure($target));
                        $this.dom.$body.children('.content-popup').filter(':visible').remove();
                        $this.$popup = $this.dom.$body.children('.trigger-popup');
                    } else {
                        $this.$popup = $target;
                        $this.$popup.attr('triggername', $(e.currentTarget).attr('name'));
                    }

                    $this.open();
                }

            });
        });
    }

    eventClosePopup() {
        this.dom.$body.off('click', '.content-popup-close').on('click', '.content-popup-close', (e) => {
            e.preventDefault();
            let $popupCont = $(e.currentTarget).closest('.content-popup');
            if ($popupCont.find('.accordion-trigger').length > 0) {
                let $trigger = $popupCont.find('.accordion-trigger');
                if ($popupCont.find($trigger.data('target')).is(':visible')) {
                    $trigger.trigger('click');
                }
            }

            this.close($(e.currentTarget).closest('.content-popup'));
        });
    }

    eventResize() {
        this.dom.$window.on('resize', debounce(200, this.setPopupPosition.bind(this)));
    }
}
